/**
 * LogoIcon — shared LocalGenie brand mark
 *
 * MapPin + Sparkles composition (originally generated by v0.app, then
 * adapted to plain JSX). The pin uses currentColor so it adapts to
 * whatever color is set on the parent (typically --accent-primary).
 *
 * Used by SplashScreen, AIChat, SubmitReview, SiteFeedback. Previously
 * each page had its own inline copy; consolidated 2026-05-03 (Sunday
 * polish session, second pass) so the brand is updated in one place.
 *
 * Sizing is controlled via the `size` prop (defaults to 28px).
 */

import React from 'react';

const LogoIcon = ({ size = 28 }) => (
  <span
    className="lg-logo-svg-wrap"
    aria-hidden="true"
    style={{
      width: size,
      height: size,
      position: 'relative',
      display: 'inline-flex',
      color: 'var(--accent-primary, #4F46E5)',
      flexShrink: 0
    }}
  >
    {/* Map pin — main icon (currentColor for fill + stroke).
        15% fill so the inside has a soft tinted-glass feel. */}
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: '100%', height: '100%', display: 'block' }}
    >
      <path
        d="M20 10c0 7-8 13-8 13s-8-6-8-13a8 8 0 0 1 16 0Z"
        fill="currentColor"
        fillOpacity="0.15"
      />
      <circle cx="12" cy="10" r="3" fill="currentColor" />
    </svg>

    {/* Sparkles — small star overlay at top-right corner.
        Uses fixed slate stroke so it reads against the indigo pin. */}
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="#475569"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        position: 'absolute',
        top: '-4px',
        right: '-6px',
        width: '50%',
        height: '50%',
        display: 'block'
      }}
    >
      <path
        d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
        fill="rgba(100, 116, 139, 0.3)"
      />
      <path d="M20 3v4" />
      <path d="M22 5h-4" />
      <path d="M4 17v2" />
      <path d="M5 18H3" />
    </svg>
  </span>
);

export default LogoIcon;
